const { default: axios } = require("axios");
import Swiper from 'swiper/bundle';
import Masonry from 'masonry-layout';
import imagesloaded from 'imagesloaded';
import 'swiper/css/bundle';
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import "@fancyapps/ui/dist/fancybox.css";

var headerEl = document.querySelector('#wrapall');
var gap, headerH = 0;

const observer = new IntersectionObserver((e) => {
    e.forEach((e)=>{
        if(e.isIntersecting) {
            e.target.classList.add('visible');
        } else {
            e.target.classList.remove('visible');
        }
    })
})

const resizetrigger = function() {

    document.querySelectorAll('.wp-block-kf-bild-text').forEach(function(ff) {
        let ww = window.innerWidth;
        let id = "#"+ff.id;
        var wh = 0;
        if(document.querySelector(id+" h3")) {
            wh = document.querySelector(id+" h3").clientWidth;
        }
        if(document.querySelector(id+" .button")) {
            var wb = document.querySelector(id+" .button").clientWidth;
        }
        if(ww >= 1280) {
            if(ff.classList.contains("width-headline")) {
                document.querySelector(id+" .text-inner").style.width = wh+"px";
            }
            if(ff.classList.contains("width-button")) {
                document.querySelector(id+" .text-inner").style.width = wb+"px";
            }
        } else {
                document.querySelector(id+" .text-inner").style.width = "auto";
        }
        ff.classList.add("show");
    });

}

window.addEventListener('load',function() {
 
    var gap = 10;
    
    if(document.getElementById('gapProxy')) {
        gap = document.getElementById('gapProxy').clientWidth;
    }

    new Swiper(':not(.is-admin).wp-block-kf-hero .swiper-container',{
        effect: 'fade',
        speed: 860,
        navigation: {
            prevEl: '.wp-block-kf-hero .prev',
            nextEl: '.wp-block-kf-hero .next'
        },
        pagination: {
            el: '.wp-block-kf-hero .pagination',
            type: 'bullets',
        },
    });

    let kfteam = new Swiper('.wp-block-kf-team .swiper-container',{
        slidesPerView: 1,
        spaceBetween: gap,
        speed: 860,
        loop: true,
        lazy: true,
        navigation: {
            prevEl: '.wp-block-kf-team .prev',
            nextEl: '.wp-block-kf-team .next'
        },
        pagination: {
            el: '.wp-block-kf-team .pagination',
            type: 'bullets',
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        }
    });

    let kftexts = new Swiper(':not(.is-admin).wp-block-kf-text-slider .swiper-container',{
        speed: 860,
        navigation: {
            prevEl: '.wp-block-kf-text-slider .prev',
            nextEl: '.wp-block-kf-text-slider .next'
        },
        on: {
            init: function() {
                let eyebrow = document.querySelector('.wp-block-kf-text-slider .swiper-slide-active span.eyebrow').innerHTML;
                let kursiv = document.querySelector('.wp-block-kf-text-slider .swiper-slide-active span.headline_kursiv').innerHTML;
                let fett = document.querySelector('.wp-block-kf-text-slider .swiper-slide-active span.headline_fett').innerHTML;
                let slide = 1+this.activeIndex;
                document.querySelector('.wp-block-kf-text-slider .headline .eyebrow').innerHTML = eyebrow;
                document.querySelector('.wp-block-kf-text-slider .headline .h2 .em').innerHTML = kursiv;
                document.querySelector('.wp-block-kf-text-slider .headline .h2 .strong').innerHTML = fett;
                document.querySelector('.wp-block-kf-text-slider .headline').classList.add('show')
            },
            slideChangeTransitionStart: function() {
                document.querySelector('.wp-block-kf-text-slider .headline').classList.remove('show')
            },
            slideChangeTransitionEnd: function() {
                let eyebrow = document.querySelector('.wp-block-kf-text-slider .swiper-slide-active span.eyebrow').innerHTML;
                let kursiv = document.querySelector('.wp-block-kf-text-slider .swiper-slide-active span.headline_kursiv').innerHTML;
                let fett = document.querySelector('.wp-block-kf-text-slider .swiper-slide-active span.headline_fett').innerHTML;
                let slide = 1+this.activeIndex;
                document.querySelector('.wp-block-kf-text-slider .headline .eyebrow').innerHTML = eyebrow;
                document.querySelector('.wp-block-kf-text-slider .headline .h2 .em').innerHTML = kursiv;
                document.querySelector('.wp-block-kf-text-slider .headline .h2 .strong').innerHTML = fett;
                document.querySelector('.wp-block-kf-text-slider .headline').classList.add('show')
            }
        }
    });

    let kfquotes = new Swiper(':not(.is-admin).wp-block-kf-zitate-slider .swiper-container',{
        speed: 860,
        navigation: {
            prevEl: '.wp-block-kf-zitate-slider .prev',
            nextEl: '.wp-block-kf-zitate-slider .next'
        }
    });

    /*******************************************/
    /*
    /*  Bild / Text
    */

    resizetrigger();

    this.window.addEventListener("resize",function() {
        resizetrigger();
    })

    /*******************************************/
    /*
    /*  Intersect Observer
    */

    document.querySelectorAll('.wp-block').forEach((e)=>{
        observer.observe(e);
        e.classList.add('visible');
    })

    /*******************************************/
    /*
    /*  Header
    */

    if(headerEl) {

        headerH = headerEl.clientHeight;
    
        window.addEventListener("scroll",function() {
            var rect = headerEl.getBoundingClientRect();
            var headerOut = ( rect.y < -24);
            if( headerOut ) {
                document.getElementById("header").classList.add("fixed");
            } else {
                document.getElementById("header").classList.remove("fixed");
            }
        });

    }

    if(document.getElementsByClassName('wp-block-kf-hero')) {
        document.getElementById("header").classList.add("transsparent");
    }

    document.getElementById("rwd_menu_link").addEventListener("click",function() {
        document.getElementById("rwd_menu_link").classList.toggle("show");
        document.getElementById("mobile_menu").classList.toggle("show");
        document.getElementById("body").classList.toggle("fixed");
    });
    
    /*******************************************/
    /*
    /*  Masonry
    */

   
    if(document.querySelector('.blog.wrap')) {
        imagesloaded( '.blog .wrap.blog', function() {
             var w = document.querySelector('.blog.wrap .post').clientWidth;
             var grid = document.querySelector('.blog');
             var gap = document.querySelector('.gap').clientWidth;
             window.setTimeout(function(){
                 var msnry = new Masonry( grid, {
                     itemSelector: '.post',
                     columnWidth: 'a.post',
                     gutter: gap,
                 });
                 document.querySelector('.blog').classList.add('show');
             },1000);
         })
    }

});
